module.exports = __webpack_public_path__ + "static/media/scroll3.db9aa6bd.png";